module.exports = __webpack_public_path__ + "img/bus-gray-sentosa.a09ea9d2.svg";